<mat-dialog-content id="dialog-content">
  <div id="header">
    <div>
      <label>{{'Quantité' | translate}} :</label>
      <input #quantity (keydown)="onInputKeyDown($event)" (change)="onQtyChange()" tabindex="1" type="number" name="Quantity" size="15" min={{NbMinQtyMesh}}>
    </div>
    <div>
      <label>{{'Repère' | translate}} :</label>
      <input #barmark (keydown)="onInputKeyDown($event)" tabindex="1" type="text" name="Barmark" size="15">
    </div>
    <div>
      <label>{{'Numéro item' | translate}} :</label>
      <input #itemNumber (keydown)="onInputKeyDown($event)" tabindex="1" type="text" name="Item number" size="15" maxlength="10">
    </div>
    <div>
      <label>{{'Libellé' | translate}} :</label>
      <input #itemName (keydown)="onInputKeyDown($event)" tabindex="1" type="text" name="Name" size="15">
    </div>
    <div>
      <label>{{'Remarque' | translate}} :</label>
      <input #remark (keydown)="onInputKeyDown($event)" tabindex="1" type="text" name="Remark" size="15">
    </div>
  </div>

  <table id="left-side">
    <tr>
      <th></th>
      <th class="red">{{'Barre verticale' | translate}}</th>
      <th class="blue">{{'Barre horizontale' | translate}}</th>
    </tr>
    <tr>
      <td>{{'Diamètre' | translate}}</td>
      <td><input #diameterVertical
                 [id]="HTML_MESH_INPUT_ID.diameterVertical"
                 (focusout)="onInputFocusOut($event)"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 tabindex="2"
                 type="text"
                 name="Diameter Vertical"
                 size="5"></td>
      <td><input #diameterHorizontal
                 [id]="HTML_MESH_INPUT_ID.diameterHorizontal"
                 (focusout)="onInputFocusOut($event)"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 tabindex="3"
                 type="text"
                 name="Diameter Horizontal"
                 size="5"></td>
    </tr>
    <tr>
      <td>{{'Longueur' | translate}} ({{unitDimPlaqueMesh}})</td>
      <td><input #totalLengthHorizontal
                 [id]="HTML_MESH_INPUT_ID.totalLengthHorizontal"
                 type="text"
                 size="5"
                 tabindex="2"
                 (focusin)="onTotalFocusIn($event)"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 [(ngModel)]="HTML_TotalLengthHorizontal">
      </td>
      <td><input #totalLengthVertical
                 [id]="HTML_MESH_INPUT_ID.totalLengthVertical"
                 type="text"
                 size="5"
                 tabindex="3"
                 (focusin)="onTotalFocusIn($event)"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 [(ngModel)]="HTML_TotalLengthVertical">
      </td>
    </tr>
    <tr>
      <td>{{'Pas' | translate}} ({{unitDimPlaqueMesh}})</td>
      <td><input #stepVertical
                 [id]="HTML_MESH_INPUT_ID.stepVertical"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="3"
                 type="text"
                 name="Step Vertical"
                 size="5"></td>
      <td><input #stepHorizontal
                 [id]="HTML_MESH_INPUT_ID.stepHorizontal"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="2"
                 type="text"
                 name="Step Horizontal"
                 size="5"></td>
    </tr>
    <tr>
      <td>{{'Début' | translate}} ({{unitDimPlaqueMesh}})</td>
      <td><input #startMeasureVertical
                 [id]="HTML_MESH_INPUT_ID.startMeasureVertical"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="3"
                 type="text"
                 size="5"></td>
      <td><input #startMeasureHorizontal
                 [id]="HTML_MESH_INPUT_ID.startMeasureHorizontal"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="2"
                 type="text"
                 size="5"></td>
    </tr>
    <tr>
      <td>{{'Fin' | translate}} ({{unitDimPlaqueMesh}})</td>
      <td><input #endMeasureVertical
                 [id]="HTML_MESH_INPUT_ID.endMeasureVertical"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="3"
                 type="text"
                 size="5"></td>
      <td><input #endMeasureHorizontal
                 [id]="HTML_MESH_INPUT_ID.endMeasureHorizontal"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="2"
                 type="text"
                 size="5"></td>
    </tr>
    <tr>
      <td>{{'Nb barres' | translate}}</td>
      <td><input #nbBarsVertical
                 [id]="HTML_MESH_INPUT_ID.nbBarsVertical"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="3"
                 type="text"
                 name="Nb bars Vertical"
                 size="5"></td>
      <td><input #nbBarsHorizontal
                 [id]="HTML_MESH_INPUT_ID.nbBarsHorizontal"
                 (keydown)="onInputKeyDown($event)"
                 (change)="onValueMeshChange($event)"
                 (focus)="onInputFocusIn($event)"
                 (focusout)="onInputFocusOut($event)"
                 tabindex="2"
                 type="text"
                 name="Nb bars Horizontal"
                 size="5"></td>
    </tr>

    <tr *ngIf="HTML_TotalWeightRounded">
      <td>{{'Poids' | translate}}</td>
      <td colspan="2">{{HTML_TotalWeightRounded}} kg</td>
    </tr>
  </table>


  <div class="preview-container" #rightSide id="right-side">
    <ng-container *ngIf="HTML_ShowRealShape && HTML_SafeUrlImgShape; else elseShowClasicShape">
      <img class="mix-color" [src]="HTML_SafeUrlImgShape" draggable="false" alt="shape image">
    </ng-container>
    <ng-template #elseShowClasicShape>
      <canvas #canvasMesh height="200" width="200"></canvas>
    </ng-template>
  </div>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-raised-button tabindex="4" (click)="onBtnClick('OK')">{{'OK' | translate}}</button>
    <button mat-raised-button tabindex="4" color="warn" (click)="onBtnClick('CANCEL')">{{'Annuler' | translate}}</button>
    <button mat-raised-button color="accent" (click)="onBtnClick('CLEAR')">{{'Effacer' | translate}}</button>
</div>
